import {appSlice} from './app.reducer';

export const {changeTheme, changeNetwork, changeCurrency} = appSlice.actions;
